import { render, staticRenderFns } from "./TissRodape.vue?vue&type=template&id=d6d1daa4&"
import script from "./TissRodape.vue?vue&type=script&lang=js&"
export * from "./TissRodape.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports